<template>
  <a-card :bordered="true" class="dashboard-bar-chart">
    <a-page-header 
      :title="item_data.vid"
      @back="() => this.$router.go(-1)"
      sub-title="个体详情" >
      <template slot="extra">
        <a-button type="primary" size="small" @click="openEdit('edit', item_data)">编辑</a-button>
      </template>
    </a-page-header>
    
    <!-- 个体详情头部（新增） -->
    <item-detail-header 
      :item-data="item_data" 
      :latest-body-data="latest_body_data"
      @edit="openEdit('edit', item_data)"
      v-if="item_data && item_data.vid"
    />

    <!-- 个体谱系 -->
    <a-card title="个体谱系" class="pedigree-section-card" :headStyle="headStyle" :loading="loading">
      <item-tree-chart ref="chart" :zoomable="false"></item-tree-chart>
    </a-card>

    <!-- 亲属关系 -->
    <a-card title="亲属关系" class="margin-top-20 family-relation-card" :headStyle="headStyle" :loading="loading">
      <pedigree-tree :item_data="item_data" v-if="item_data && item_data.vid"></pedigree-tree>
    </a-card>

    <!-- 表型数据 -->
    <biao-xing-section 
      :item-id="id" 
      :farm-id="item_data.farm_id" 
      v-if="id && item_data.farm_id" 
    />

    <!-- 产量数据分析 -->
    <production-section 
      :item-id="id" 
      :farm-id="item_data.farm_id" 
      v-if="id && item_data.farm_id" 
      @record-added="refreshTimeline"
    />

    <!-- 子代个体列表 -->
    <a-card title="子代个体列表" class="margin-top-20 child-items-card" :headStyle="headStyle" :loading="loading">
      <item-table 
        ref="itemTable" 
        :page_size="10" 
        :key="'child-table-' + id" 
        v-if="id" 
        @page-change="handleChildItemsPageChange" />
    </a-card>

    <!-- 时间线 -->
    <item-timeline ref="itemTimeline" :item-id="id" :key="'timeline-' + id" v-if="id" class="item-timeline-section" />

    <add-or-edit ref="addOrEdit"></add-or-edit>
  </a-card>
</template>

<script>
import detailSection from '@/views/breed_items/components/detailSection'
import pedigreeTree from '@/views/breed_items/components/pedigreeTree'
import itemTreeChart from '../yu_zhong/components/itemTreeChart.vue';
import addOrEdit from '@/views/breed_items/components/addOrEdit'
import biaoxingRecords from '@/views/biao_xing_records/index.vue'
import selectRecordRow from '../farms/components/selectRecordRow.vue';
import itemTimeline from '@/views/breed_items/components/itemTimeline.vue';
import biaoXingSection from '@/views/breed_items/components/biaoXingSection.vue';
import itemTable from '@/views/breed_items/components/itemTable.vue';
import ProductionSection from '@/views/breed_items/components/ProductionSection.vue';
import itemDetailHeader from '@/views/breed_items/components/itemDetailHeader.vue';
export default {
  name: "breed_items_detail",
  components: {
    detailSection, pedigreeTree, itemTreeChart, addOrEdit, biaoxingRecords, selectRecordRow, itemTimeline, biaoXingSection, itemTable, ProductionSection, itemDetailHeader
  },
  data() {
    return {
      loading: false,
      id: 0,
      vid: "",
      rf_id: "",
      father: "",
      mother: "",
      birth_date: "",
      gender: "",
      item_data: {},
      headStyle: {
        backgroundColor: '#2563EB', // 自定义 header 背景色
        color: '#efefef', // 自定义 header 文字颜色
        "border-radius": '10px 10px 0px 0px',
        "font-weight": 'bold'
      },
      select_records: [],
      select_records_page: {
        page: 1,
        page_size: 10,
        total: 0
      },
      latest_body_data: {
        weight: null,
        height: null
      }
    };
  },
  mounted() {
    this.id = parseInt(this.$route.params.id);
    this.loadData(parseInt(this.$route.params.id))
  },
  watch: {
    $route(to, from) {
      // 确保组件完全加载后再更新数据
      this.$nextTick(() => {
        this.loadData(parseInt(to.params.id))
      });
    }
  },
  methods: {
    async loadData(id) {
      this.id = id; // 确保 this.id 被更新为最新的 ID
      this.loading = true
      try {
        const res = await this.$api.get_breed_item_by_id(id)
        this.item_data = res.data
        
        const select_record_res = await this.$api.get_item_select_records({
          breed_item_id: id
        })
        this.select_records = select_record_res.data
        this.select_records_page.page = select_record_res.page

        // 获取最新的表型数据
        await this.loadLatestBodyData(id)

        this.loading = false
        
        // 等待 loading 结束后再绘制图表
        this.$nextTick(() => {
          if (this.$refs.chart && typeof this.$refs.chart.draw === 'function') {
            this.$refs.chart.draw(res.tree_data)
          }
          
          // Load child items after chart is drawn
          this.loadChildItems(id);  // 传递最新的 id
          
          // 延迟刷新 timeline，确保组件完全更新
          setTimeout(() => {
            if (this.$refs.itemTimeline && typeof this.$refs.itemTimeline.refresh === 'function') {
              this.$refs.itemTimeline.refresh();
            }
          }, 100);
        })
      } catch (error) {
        console.error('加载数据失败:', error)
        this.$message.error('加载数据失败')
        this.loading = false
      }
    },
    async loadChildItems(currentId, page_no = 1) {
      try {
        // 使用专门的API获取子代个体
        const params = {
          page_no: page_no,
          page_size: 10,
        };
        
        const res = await this.$api.get_breed_item_children(currentId, params);
        
        // 根据实际返回的数据结构处理
        const list = res.data?.list || [];
        const pageInfo = res.data?.page || {};
        
        // 设置分页信息
        const pagination = {
          pageSize: pageInfo.page_size || 10,
          current: pageInfo.page_no || page_no,
          total: pageInfo.total || list.length,
          showTotal: total => `共 ${total} 条记录`
        };
        
        // Use the itemTable's open method to populate the table
        if (this.$refs.itemTable && typeof this.$refs.itemTable.open === 'function') {
          this.$refs.itemTable.open(list, pagination);
        }
      } catch (error) {
        console.error('加载子代个体失败:', error);
        this.$message.error('加载子代个体失败');
      }
    },
    handleChildItemsPageChange(pagination) {
      // 当子代列表分页变化时，重新加载对应页的数据
      this.loadChildItems(this.id, pagination.current);
    },
    openEdit(action, item) {
      if (action == 'add') {
        this.$refs.addOrEdit.open('add', item)
      } else {
        this.$refs.addOrEdit.open('edit', item)
      }
    },
    refreshTimeline() {
      this.$nextTick(() => {
        if (this.$refs.itemTimeline && typeof this.$refs.itemTimeline.refresh === 'function') {
          this.$refs.itemTimeline.refresh();
        }
      });
    },
    async loadLatestBodyData(itemId) {
      try {
        const res = await this.$api.get_biao_xing_records({
          breed_item_id: itemId,
          page_no: 1,
          page_size: 1
        });
        
        if (res.data && res.data.length > 0) {
          const latestRecord = res.data[0];
          this.latest_body_data = {
            weight: latestRecord.weight,
            height: latestRecord.height
          };
        } else {
          this.latest_body_data = {
            weight: null,
            height: null
          };
        }
      } catch (error) {
        console.error('加载表型数据失败:', error);
        this.latest_body_data = {
          weight: null,
          height: null
        };
      }
    },
  }
}
</script>

<style scoped>
.margin-top-20 {
  margin-top: 20px;
}

.margin-top-30 {
  margin-top: 30px;
}
</style>